// extracted by mini-css-extract-plugin
export default {"selectContainer":"PresetMenu_selectContainer__KkQLm"};